import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import useFirebaseCart from './useFirebaseCart';
import BottomNav from './BottomNav';
import '../styles/Cart.css';
export default function Cart() {
  const { storeId, tableNo } = useParams();
  const { language } = useLanguage();
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [comment, setComment] = useState('');
  const [tempComment, setTempComment] = useState('');
  const { cartItems, confirmedOrders, cartTotal, confirmedTotal, isProcessing, error,
    loadCart, fetchOrders, changeQty, removeItem, confirmOrder: checkout } = useFirebaseCart(storeId, tableNo);
  const refresh = () => { loadCart(); fetchOrders().catch(() => {}); };
  const handleAddComment = () => {
    setTempComment(comment);
    setShowCommentInput(true);
  };

 
  const handleOkComment = () => {
    setComment(tempComment);
    setShowCommentInput(false);
  };
 
  const handleCancelComment = () => {
    setTempComment(comment);
    setShowCommentInput(false);
  };

 
  const handleCommentChange = (e) => {
    setTempComment(e.target.value);
  };

  async function confirmOrder() {
    const success = await checkout(comment);
    if (success) {
      setComment(''); setShowCommentInput(false);
    }
  }
  return (
    <div className="cart-page">
      {error && <p role="alert">{error}</p>}
      <div className="top-half">
        <div className="title-container">
          <div className="title-spacer" />
          <h2 className="title-bold">{language === "cn" ? "My Cart" : "我的购物车"}</h2>
          <button className="refresh-btn" onClick={refresh} disabled={isProcessing}>
            ⟳
          </button>
        </div>
        
        {cartItems.map(item => (
          <div key={item._id} className="cart-item">
            <div className="item-name">
              {language === "cn" ? item.itemnamecn : item.itemname}
            </div>

            <div className="qty-group">
              <button
                className="minus" disabled={isProcessing}
                onClick={() => changeQty(item._id, -1)}
              >
                −
              </button>
              <span className="quantity">{item.quantity}</span>
              <button
                className="plus" disabled={isProcessing}
                onClick={() => changeQty(item._id, 1)}
              >
                +
              </button>
            </div>

            <div className="price">
              Rs. {item.price}
            </div>

            <button
              className="delete" disabled={isProcessing}
              onClick={() => removeItem(item._id)}
            >
              {language === "cn" ? "Remove" : "删除"}
            </button>
          </div>
        ))}
      </div>

      <div className="divider" />

      <div className="bottom-half">
        <div className="section-title-container">
          <h3 className="section-title-bold">{language === "cn" ? "Confirmed Orders" : "已确认订单"}</h3>
        </div>

        {confirmedOrders.length ? (
          <>
            {confirmedOrders.map(item => (
              <div key={item._id} className="order-item">
                <span className="name">{language === "cn" ? item.itemnamecn : item.itemname}</span>
                <span className="qty">x{item.quantity}</span>
                <span className="price">Rs. {item.price}</span>
              </div>
            ))}

            <div className="order-total">
              <span className="order-total-label">{language === "cn" ? "Total:" : "合计"}</span>
              <span className="order-total-amount">
                Rs. {confirmedTotal}
              </span>
            </div>
          </>
        ) : (
          <div className="empty">{language === "cn" ? "No confirmed items" : "没有订单"}</div>
        )}
      </div>

      <div className="bottom-bar">
        <span className="total">{language === "cn" ? "Cart Total:" : "购物车合计"}</span>
        <span className="order-total-amount">
          Rs. {cartTotal}
        </span>
        
      
        <button
          className="add-comment-btn"
          onClick={handleAddComment}
          disabled={showCommentInput}
        >
          {language === "cn" ? "Add Comment" : "添加评论"}
        </button>
        
        <button
          className="confirm"
          disabled={isProcessing || !cartItems.length}
          onClick={confirmOrder}
        >
          <div className="empty">{language === "cn" ? "Confirm" : "确认"}</div>
        </button>
      </div>

      
      {showCommentInput && (
        <div className="comment-modal">
          <div className="comment-modal-content">
            <textarea
              className="comment-input"
              value={tempComment}
              onChange={handleCommentChange}
              placeholder={language === "cn" ? "Enter your comment..." : "输入评论..."}
              rows="3"
            />
            <div className="comment-modal-buttons">
              <button className="comment-ok-btn" onClick={handleOkComment}>
                {language === "cn" ? "OK" : "确定"}
              </button>
              <button className="comment-cancel-btn" onClick={handleCancelComment}>
                {language === "cn" ? "Cancel" : "取消"}
              </button>
            </div>
          </div>
        </div>
      )}
      
      <BottomNav />
    </div>
  );
}